import React from "react";

/* Safety net: if any route throws during render/unmount (e.g. third-party DOM
   mutation from RefTagger), show a recoverable fallback instead of a blank
   white screen. Auto-resets whenever the route (resetKey) changes. */
export default class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.warn("Route error caught by boundary:", error);
  }

  componentDidUpdate(prev) {
    if (prev.resetKey !== this.props.resetKey && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center">
          <p className="font-serif text-2xl text-foreground">Let&apos;s try that again.</p>
          <button
            onClick={() => this.setState({ hasError: false })}
            className="rounded-full bg-primary px-6 py-2.5 text-sm font-semibold text-primary-foreground hover:bg-primary/90"
            data-testid="route-error-retry"
          >
            Reload this page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
